export default __webpack_public_path__ + "static/media/dedication.10bfba9f.jpeg";